import React from 'react';
import './index.scss';
import clsx from 'clsx';

const PcSuggestList = ({ items = [], onClick, fullWidth = false }) => {
  return(
    <div className={clsx(
      'PcSuggestList',
      { many: items.length > 5 },
      { nolist: items.length === 0 },
      { fullWidth },
    )}
    >
      <ul className="listArea">
        <div className="upArrowArea upArrow" />
        <div className="list-wrapper">  
          {items.map((item, key) => {
            return (
              <li className="list" key={item} id="pcSuggestItem">
                <button
                  className="button"
                  type="button"
                  tabIndex="0"
                  onClick={() => onClick(key)}
                >
                  {item}
                </button>
              </li>
            );
          })}
        </div>        
      </ul>
    </div>
  );
};

export default PcSuggestList;